import { memo, cloneElement } from 'react';
import { Link } from 'gatsby';
import classNames from 'classnames'
import _isNil from 'lodash/isNil';
import _isFunction from 'lodash/isFunction';
import useIsAddedToCart from '../modules/FastSpringStore/useIsAddedToCart';
import useFastSpringStore from '../modules/FastSpringStore/useFastSpringStore';
import { addToCart } from '../modules/FastSpringStore/FastSpringStore.module';

export default memo(({productId, bfd, children, className, onClick, setShowCart, addedToCartAddon, cartRoute = '/cart', ...props }) => {
	const [, dispatch] = useFastSpringStore()
	const isAddedToCart = useIsAddedToCart(productId)

	if (isAddedToCart) {
		return (
			<>
				{
					setShowCart ?
					<button onClick={() => setShowCart(true)} className={`${className} toCheckout`}>
						{cloneElement(children, { isAddedToCart })}
					</button>
					:
					<Link to={cartRoute} className={`btn ${className} ${bfd ? 'bg-black hover-white-text' : 'btn-success'}`}>
						{cloneElement(children, { isAddedToCart })}
					</Link>
				}
				{addedToCartAddon}
			</>
		)
	}

	return (
		<button className={classNames(`btn ${bfd ? 'bg-blue hover-black hover-white-text' : 'btn-danger'}`, className)}
			onClick={() => {
				if (!_isNil(window)) {
					window.fastspring.builder.add(productId)
				}

				dispatch(
					addToCart(productId)
				)

				_isFunction(onClick) && onClick(productId)
			}}
			{...props}
		>
			{children}
		</button>
	)
})
